// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"0215fd37","869":"0215fd37","953":"0215fd37"}[chunkId] + ".chunk.css";
};